import { useEffect, useRef, useState } from 'react';
import { FaCheck, FaEye, FaEyeSlash } from 'react-icons/fa';
import { ImCross } from "react-icons/im";
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import { AutoCompleteBoxNew, FormButton, InputBox } from '../CommonComponents/InputBox';
function ResetPassword() {
    const [resetPasswordData, setResetPasswordData] = useState({ userCode: '', newPassword: '', confirmPassword: '' });
    const [showPassword, setShowPassword] = useState(false);
    const inputrefs = useRef([])
    const dispatch = useDispatch([])

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/ResetPassword`, { ...resetPasswordData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleReset);
    };
    const [policyValidations, setPolicyValidations] = useState({
        noWhitespace: false,
        length: false,
        matchConfirmPassword: false,
        complexity: false
    });

    const handleReset = () => {
        setResetPasswordData({ userCode: '', newPassword: '', confirmPassword: '' });
        setPolicyValidations({
            noWhitespace: false,
            length: false,
            matchConfirmPassword: false,
            complexity: false
        });
        setShowPassword(false)
    }
    const validatePassword = (password, confirmPassword) => {
        if (password !== '') {
            const noWhitespace = !/\s/.test(password);
            const length = password.length >= 8 && password.length <= 15;
            const complexity = /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) && /[!@#$%^&*(),.?":{}|<>]/.test(password);
            setPolicyValidations({
                noWhitespace,
                length,
                matchConfirmPassword: password === confirmPassword,
                complexity
            });
        } else {
            setPolicyValidations({
                noWhitespace: false,
                length: false,
                matchConfirmPassword: false,
                complexity: false
            });
        }
    };

    const handlePasswordChange = (field, value) => {
        setResetPasswordData({ ...resetPasswordData, [field]: value });

        if (field === 'newPassword') {
            validatePassword(value, resetPasswordData.confirmPassword);
        } else if (field === 'confirmPassword') {
            validatePassword(resetPasswordData.newPassword, value);
        }
    };

    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };
    useEffect(() => {
        inputrefs.current['txtUserCode'].focus()
        document.title = 'Reset Password'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Reset Password'} </h6>
                    </div>
                    <div className='card-body pb-3'>
                        <div className='row'>
                            <div className='col-sm-4'>

                                <AutoCompleteBoxNew
                                    id="txtUserCode"
                                    placeholder="User"
                                    divclassname='mb-2'
                                    label='User'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtNewPassword"].focus(); };
                                    }}
                                    autocompleteType='GetUser'
                                    value={resetPasswordData.userCode || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setResetPasswordData({ ...resetPasswordData, userCode: newInputValue })
                                        }
                                    }}
                                    maxLength='50'
                                />

                                <div className="d-flex mb-1" style={{ position: "relative" }}>
                                    <InputBox
                                        required={true}
                                        maxLength='15'
                                        divclassname='col-md-12 col-12 mb-2'
                                        label='New Password'
                                        placeholder='New Password'
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtConfirmPassword'].focus()
                                            }
                                        }}
                                        id="txtNewPassword"
                                        type={showPassword.newPassword ? 'text' : 'password'}
                                        value={resetPasswordData.newPassword}
                                        onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                                    />
                                    <span style={{ position: "relative", right: "26px", top: "21px", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('newPassword')}>
                                        {showPassword.newPassword ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                    </span>
                                </div>

                                <div className="d-flex mb-1" style={{ position: "relative" }}>
                                    <InputBox
                                        label={'Confirm Password'}
                                        placeholder={'Confirm Password'}
                                        required={true}
                                        divclassname='col-md-12 col-12 mb-2'
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['btnSub'].focus()
                                            }
                                        }}
                                        id="txtConfirmPassword"
                                        maxLength='15'
                                        type={showPassword.confirmPassword ? 'text' : 'password'}
                                        value={resetPasswordData.confirmPassword}
                                        onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                                    />
                                    <span style={{ position: "relative", right: "26px", top: "21px", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('confirmPassword')}>
                                        {showPassword.confirmPassword ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                    </span>
                                </div>
                                <FormButton
                                    id={'btnSub'}
                                    inputrefs={inputrefs}
                                    handleSubmit={handleSubmit}
                                    Export={false}
                                    handleClear={handleReset}
                                />
                            </div>
                            <div className='col-sm-8'>
                                <div className='password-policy-border'>
                                    <div className='w-100 py-2 password-policy px-3'>
                                        <h6 className="m-0 font-weight-bold text-white">{'Password Policy'}</h6>
                                    </div>
                                    <div className='p-3'>
                                        <div className="form-group change_password px-2">
                                            <ol>
                                                <li className='changepara' >
                                                    White spaces not allowed. {policyValidations.noWhitespace ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                                <li className='changepara'>
                                                    Password must be 8 to 15 character(s). {policyValidations.length ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>

                                                <li className='changepara'>
                                                    Password must be combination of at least one numeric and one uppercase letter and one lowercase and special character [$#!()]. {policyValidations.complexity ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                                <li className='changepara'>
                                                    New password and confirm password should be same. {policyValidations.matchConfirmPassword ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ResetPassword;